import React from 'react';
import { makeStyles } from '@material-ui/core';
import bg from 'static/media/bg.jpg';

interface LayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
    background: `url(${bg}) 100% `,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));

const LoginLayout: React.FC<LayoutProps> = (props) => {
  const { children } = props;
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export { LoginLayout };
